import React from 'react';
import { bool, func } from 'prop-types';
import styled from 'styled-components';

const Container = styled.button`
  position: absolute;
  top: 18px;
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  span {
    width: 2rem;
    height: 0.25rem;
    background: black;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    background: ${props => props.isOpen ? 'white' : 'black'};
    opacity: 0.8;
    box-shadow: 5px black;
    :first-child {
      transform: ${props => props.isOpen ? 'rotate(45deg)' : 'rotate(0)'};
    }
    :nth-child(2) {
      opacity: ${props => props.isOpen ? '0' : '1'};
      transform: ${props => props.isOpen ? 'translateX(20px)' : 'translateX(0)'};
    }
    :nth-child(3) {
      transform: ${props => props.isOpen ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }

  &:focus {
    outline: none;
  }
`;

const Burger = ({isOpen, setIsOpen}) => {
  const isExpanded = isOpen ? true : false;

  return (
    <Container
      aria-label="Toggle menu"
      aria-expanded={isExpanded} 
      onClick={() => setIsOpen(!isOpen)}
      isOpen={isOpen}
     >
      <span />
      <span />
      <span />
    </Container>
  )
}

Burger.propTypes = {
  isOpen: bool.isRequired,
  setIsOpen: func.isRequired,
};

export default Burger;